import { useNavigate } from "react-router-dom";
import { RouterPaths } from "../../../../router/router";

const Industries = ({ subMenuWidth, openIndustries, iSubManuItem, closeAllManu, setISubManuItem, height }) => {
  const navigate = useNavigate();
  return (
    <div
      onMouseEnter={() => openIndustries()}
      onMouseLeave={() => closeAllManu()}
      className={`absolute z-[10001]`}
      style={{ left: `${subMenuWidth.offsetLeft - 305}px` }}
    >
      <div className="mr-[33px]" style={{ top: `${height}px`, width: `${subMenuWidth.offsetWidth + 305}px` }}>
        <div className="bg-[#F2F2F2]">
          <div className="grid grid-cols-4 gap-4">
            <div className="col-span-1 border-r-[1px] border-r-[#292929]">
              <div className="border-b-[1px] border-b-black py-[8px] cursor-pointer">
                <div
                  className={`${iSubManuItem == "GOVERNMENT" ? "border-l-[#7ABF5B] font-bold" : "border-l-[#292929] font-normal"
                    }  text-[20px] font-[Roboto] text-[#000] border-l-[11px] px-[34px] py-[26px]`}
                  onMouseEnter={() => setISubManuItem("GOVERNMENT")}
                >
                  GOVERNMENT
                </div>
              </div>
              <div className="border-b-[1px] border-b-black py-[8px] cursor-pointer">
                <div
                  className={`${iSubManuItem == "DEFENSE" ? "border-l-[#7ABF5B] font-bold" : "border-l-[#292929] font-normal"
                    }  text-[20px] font-[Roboto] text-[#000] border-l-[11px] px-[34px] py-[26px]`}
                  onMouseEnter={() => setISubManuItem("DEFENSE")}
                >
                  DEFENSE
                </div>
              </div>
              <div className="border-b-[1px] border-b-black py-[8px] cursor-pointer">
                <div
                  className={`${iSubManuItem == "COMMERCIAL" ? "border-l-[#7ABF5B] font-bold" : "border-l-[#292929] font-normal"
                    }  text-[20px] font-[Roboto] text-[#000] border-l-[11px] px-[34px] py-[26px]`}
                  onMouseEnter={() => setISubManuItem("COMMERCIAL")}
                >
                  COMMERCIAL
                </div>
              </div>
            </div>

            {/* GOVERNMENT */}
            {iSubManuItem == "GOVERNMENT" ? (
              <div className="col-span-3 mx-[47px]">
                <div className="pt-[35px] pb-[25px] border-b-[1px] border-b-[#292929] font-bold text-[20px] font-[Roboto] text-[#000]">
                  GOVERNMENT
                </div>
                <div className="flex mt-[41px]">
                  {/* Left Side - Auto Width */}
                  <div className="flex-grow col-span-2 border-r-[1px] border-r-[#292929]">
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Federal
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      State
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Municipal
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Emergency Response
                    </div>
                  </div>

                  {/* Right Side - Fixed Width */}
                  <div className="w-[450px] px-[40px]">
                    <div>
                      <div className="font-bold text-[20px] font-[Roboto] text-[#000]">
                        Contact A Government Representative Today
                      </div>
                      <div>
                        <div className="font-normal text-[20px] font-[Roboto] text-[#000] mt-[20px]">
                          Serve and respond with the best equipment through a Government Representative today.
                        </div>
                      </div>
                    </div>
                    <div className=" mt-[46px] mb-[82px]">
                      <button
                        className="w-full border-[4px] border-[#7abf5b] text-[#5b792e] font-[Roboto] text-[20px] px-[30px] py-[10px] font-bold my-[10px]"
                        style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                      >
                        CONTACT TODAY
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            {/* DEFENSE */}
            {iSubManuItem == "DEFENSE" ? (
              <div className="col-span-3 mx-[47px]">
                <div className="pt-[35px] pb-[25px] border-b-[1px] border-b-[#292929] font-bold text-[20px] font-[Roboto] text-[#000]">
                  DEFENSE
                </div>
                <div className="flex mt-[41px]">
                  {/* Left Side - Auto Width */}
                  <div className="flex-grow col-span-2 border-r-[1px] border-r-[#292929]">
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate(RouterPaths.Defend);
                        closeAllManu();
                      }}
                    >
                      Military
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate(RouterPaths.Defend);
                        closeAllManu();
                      }}
                    >
                      Agency
                    </div>
                  </div>

                  {/* Right Side - Fixed Width */}
                  <div className="w-[450px] px-[40px]">
                    <div>
                      <div className="font-bold text-[20px] font-[Roboto] text-[#000]">
                        Contact A Defense Representative Today
                      </div>
                      <div>
                        <div className="font-normal text-[20px] font-[Roboto] text-[#000] mt-[20px]">
                          Get tactical specifcto your mission needs with a Defense Representative today.
                        </div>
                      </div>
                    </div>
                    <div className="mt-[46px] mb-[82px]">
                      <button
                        className="w-full border-[4px] border-[#7abf5b] text-[#5b792e] font-[Roboto] text-[20px] px-[30px] py-[10px] font-bold my-[10px]"
                        style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                      >
                        CONTACT TODAY
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            {/* COMMERCIAL */}
            {iSubManuItem == "COMMERCIAL" ? (
              <div className="col-span-3 mx-[47px]">
                <div className="pt-[35px] pb-[25px] border-b-[1px] border-b-[#292929] font-bold text-[20px] font-[Roboto] text-[#000]">
                  COMMERCIAL
                </div>
                <div className="flex mt-[41px]">
                  {/* Left Side - Auto Width */}
                  <div className="flex-grow col-span-2 border-r-[1px] border-r-[#292929]">
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Agriculture
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Construction
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Forestry & Wildlife
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Mining, Quarries, & Refineries
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Zoos, Museums, & Recreation
                    </div>
                  </div>

                  {/* Right Side - Fixed Width */}
                  <div className="w-[450px] px-[40px]">
                    <div>
                      <div className="font-bold text-[20px] font-[Roboto] text-[#000]">Contact Your Local Dealer</div>
                      <div>
                        <div className="font-normal text-[20px] font-[Roboto] text-[#000] mt-[20px]">
                          Your local Tuatara dealer is a personal partner who will do whateverit takes to help your
                          business succeed.
                        </div>
                      </div>
                    </div>
                    <div className="mt-[46px] mb-[82px]">
                      <button
                        className="w-full border-[4px] border-[#7abf5b] text-[#5b792e] font-[Roboto] text-[20px] px-[30px] py-[10px] font-bold my-[10px]"
                        style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                      >
                        CONTACT TODAY
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Industries;
